export default __webpack_public_path__ + "css/supplierAdviceNotes.bundle.css";